import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const EmptyContacts = props => {
  return (
    <Svg
      width={105}
      height={102}
      viewBox="0 0 105 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M73.807 17.17s-7.078 18.062 20.416 34.7c24.417 14.777-.511 39.532-14.637 43.651-18.298 5.336-38.693-10.738-47.963 2.485-9.27 13.222-37.444-10.431-24.692-31.082C22.793 41.237 3.889 40.84.725 29.651-1.547 21.62 13.743-.512 31.738 6.423c15.142 5.836 17.843-.446 21.474-4.146C58.448-3.06 77.8.622 73.807 17.17z"
        fill="#4AA6E1"
        fillOpacity={0.2}
      />
      <Path
        d="M42.914 76.82c-4.572-.207-9.768-5.68-7.482-7.134 2.286-1.455 2.01-4.503 1.178-4.918-5.126-2.009-6.373-6.511-7.481-12.26-1.109-5.75-.485-24.037-.485-24.037l6.442-3.256 17.803-1.04 5.056 8.382s-1.853 5.005-2.009 10.011c1.214-.97 3.334-2.305 4.918-1.352 1.026.615 1.643 1.577 1.907 2.652.34 1.394.083 2.984-.66 4.275-.515.898-1.12 1.793-1.956 2.48-1.184.973-2.835 1.525-5.381 1.076.102 1.366 2.765 1.424 2.765 2.818 0 1.316-.05 3.325 0 4.086.416 6.235 3.81 8.382 5.542 10.46 1.731 2.078-15.586 7.966-20.157 7.758z"
        fill="#77C2F2"
      />
      <Path
        d="M29.684 51.054c2.792 0 5.056-2.461 5.056-5.498 0-3.036-2.264-5.497-5.056-5.497-2.792 0-5.056 2.461-5.056 5.497 0 3.037 2.264 5.498 5.056 5.498z"
        fill="#3876AA"
      />
      <Path
        d="M29.684 49.965c2.256 0 4.086-1.974 4.086-4.409 0-2.434-1.83-4.408-4.086-4.408-2.257 0-4.087 1.974-4.087 4.408 0 2.435 1.83 4.409 4.087 4.409z"
        fill="#fff"
      />
      <Path
        d="M43.018 51.47c2.697 0 4.883-2.294 4.883-5.125s-2.186-5.126-4.883-5.126-4.884 2.295-4.884 5.126c0 2.83 2.187 5.126 4.884 5.126z"
        fill="#3876AA"
      />
      <Path
        d="M43.017 50.678c2.148 0 3.888-1.938 3.888-4.329s-1.74-4.33-3.888-4.33c-2.147 0-3.887 1.939-3.887 4.33s1.74 4.33 3.887 4.33z"
        fill="#fff"
      />
      <Path
        d="M34.496 43.874s2.512-.955 4.166.846c0 .312-.25.84-.25.84s-2.22-1.74-3.916-.424c-.276-.545-.442-1.136 0-1.262zM47.49 45.011l8.37-2.992-.08.741-8.022 3.352-.268-1.1zM13.493 81.89a3.66 3.66 0 01.26-3.083l2.145-3.781s.277-1.478 6.558-2.355c6.28-.878 12.322-2.456 12.976-2.98 0 0 11.098 9.534 27.439-.855 0 0 13.338 7.529 16.386 7.806 1.79.163 3.183 3.688 4.027 6.569a3.64 3.64 0 01-2.705 4.575c-13.486 3-60.38 12.02-67.086-5.896zM60.145 50.625c-1.582 3.766-2.662 5.35-3.931 5.21-1.325-.148-1.743-2.29-1.654-4.174 2.662.518 4.372-.038 5.585-1.036z"
        fill="#3876AA"
      />
      <Path
        d="M62.794 43.782c-.01.03-.022.06-.033.089-.263-1.076-.881-2.037-1.906-2.652-1.627-.978-3.818.454-5.015 1.432.227-4.36-.155-9.296-2.536-10.368-4.156-1.87-4.325-1.455-6.907-1.316-2.425.13-8.368.504-9.377-.08.665.623 3.805 3.3 8.812 3.543.565.416.2.762-.355.693-.553-.07-8.104-.208-13.784-7.342 0 0-3.295 6.162-3.223 11.706 0 0-2.112-4.156-.795-10.114.795-4.433 2.84-4.018 2.84-4.018s-1.386-9.905 8.104-9.004c2.77.346 7.481 4.433 10.667 4.364 3.187-.07 6.096.139 6.096.139s4.503-.693 5.265 5.403c.033 1.227.919 1.78 3.325 2.078 2.48.307 2.078 6.719-1.178 15.447z"
        fill="#3876AA"
      />
      <Path
        d="M85.45 96.458c6.37 0 11.534-5.164 11.534-11.534 0-6.37-5.164-11.533-11.533-11.533-6.37 0-11.534 5.163-11.534 11.533 0 6.37 5.164 11.534 11.534 11.534z"
        fill="#4AA6E1"
        stroke="#fff"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <Path
        d="M89.895 83.959H86.61a.191.191 0 01-.179-.12.193.193 0 01-.015-.074v-3.284a.966.966 0 00-1.932 0v3.284a.193.193 0 01-.193.194h-3.284a.966.966 0 000 1.931h3.284a.193.193 0 01.193.194v3.284a.966.966 0 001.932 0v-3.284a.194.194 0 01.194-.194h3.284a.966.966 0 000-1.931z"
        fill="#fff"
      />
    </Svg>
  );
};

export default EmptyContacts;
